"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useAppConfig } from "@/lib/config";
export function ReferralHandler() {
  const $ = _c(4);
  const searchParams = useSearchParams();
  const {
    apiUrl
  } = useAppConfig();
  let t0;
  let t1;
  if ($[0] !== apiUrl || $[1] !== searchParams) {
    t0 = () => {
      const ref = searchParams.get("ref");
      if (ref) {
        fetch(`${apiUrl}/referral`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include",
          body: JSON.stringify({
            ref
          })
        }).catch(_temp);
      }
    };
    t1 = [searchParams, apiUrl];
    $[0] = apiUrl;
    $[1] = searchParams;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp() {}